<header matDialogTitle>
  <div>{{ data | referralAgentActionType }}</div>
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>

@switch (data) {
  @case ("create") {
    <app-create-referral-agent></app-create-referral-agent>
  }
  @case ("update") {
    <app-update-referral-agent></app-update-referral-agent>
  }
  @case ("link") {
    <app-link-account></app-link-account>
  }
}
